import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaArriAc.mjs'

export default () => {
    const CategoryNode = useCategoryNode()
    // const ArCatNode = useArCatNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return (/^(AIAC)$/.test(type))
        },

        canMountType(map, node, type) {
            return /^(CAT)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'AIAC'},
            ]
        },
    })
}
